import React, { useEffect, useRef, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import PrimaryButton from "../primary-button";
import DropdownInput from "../../components/dropdown-input";
import DynamicModal from "../dynamic-modal";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { FetchUsersByClinic, updateAssignVisit } from "../../middleware/services/home";
import Toaster from "../toaster";
import {useNavigate } from "react-router-dom";
const AssignVisit = ({ appointmentId }) => {
  const reAssignModal = useRef();
  const [DoctorList, setDoctorList] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [temporarySelections, setTemporarySelections] = useState({}); // Temporary state for selections
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const navigate = useNavigate();

  // Fetch the users and group them by role
  useEffect(() => {
    GetUsersList();
  }, []);

  const GetUsersList = async () => {
    const result = await FetchUsersByClinic({
      doctorid: "",
      appointmentid: appointmentId,
    });

    if (result.output.result === "success") {
      const fetchedDoctors = result.output.data;
      setDoctorList(fetchedDoctors);
      groupDoctorsByRole(fetchedDoctors);
    }
    //if(rolesData.length > 0){
      reAssignModal.current.openModal();
    // } else {
    //   showErrorToast("No roles found.");
    // }
  };

  const groupDoctorsByRole = (doctors) => {
    const groupedData = doctors?.reduce((acc, doctor) => {
      const roleName = doctor.rolename || "Unknown Role";
      if (!acc[roleName]) {
        acc[roleName] = {
          roleId: doctor.roleid || null,
          names: [],
          assignedTo: "",
          status: "",
        };
      }

      acc[roleName].names.push(doctor.fullname);

      if (doctor.assignedto === doctor.fullname) {
        acc[roleName].assignedTo = doctor.fullname;
        acc[roleName].status = doctor.statusname || "Pending";
      }

      return acc;
    }, {}) || {};

    const transformedRolesData = Object.entries(groupedData).map(
      ([roleName, roleData]) => ({
        roleId: roleData.roleId,
        roleName: roleName,
        assignedTo: roleData.assignedTo,
        status: roleData.status,
        options: roleData.names,
      })
    );

    setRolesData(transformedRolesData);
  };

  // Handler to track temporary selections
  const handleAssigneeChange = (roleId, selectedOption) => {
    setTemporarySelections((prev) => ({
      ...prev,
      [roleId]: selectedOption, // Temporarily track changes
    }));
  };

  // Submit the updated roles data
  const handleSubmit = async () => {
    const appointmentAssignedTo = rolesData.map((role) => {
      const selectedUser = DoctorList.find(
        (doctor) => doctor.fullname === (temporarySelections[role.roleId] || role.assignedTo)
      );

      return {
        assignto: selectedUser?.doctorid || "",
        rolename: role.roleName,
        roleid: role.roleId,
      };
    });

    const input = {
      appointmentid: appointmentId,
      doctorid: "",
      appointmentassignedto: appointmentAssignedTo,
    };

    try {
      showLoader();
      const result = await updateAssignVisit(input);
      if (result?.output.result === "success") {
        reAssignModal.current.closeModal();
        setRolesData((prev) =>
          prev.map((role) => ({
            ...role,
            assignedTo: temporarySelections[role.roleId] || role.assignedTo,
          }))
        );
        setTemporarySelections({}); // Clear temporary selections
        //showSuccessToast("Appointment successfully updated!");
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      showErrorToast("An error occurred while updating the appointment.");
    } finally {
      dismissLoader();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <DynamicModal
        ref={reAssignModal}
        modalWidth="40rem"
        modalHeader="Assign Appointment"
        modalBody={
          <Box maxH="50vh" overflow="hidden auto" pr="1rem">
            {rolesData.map((role) => (
              <Box key={role.roleId} mb={5}>
                <Flex
                  justify="space-between"
                  align="center"
                  p={2}
                  bg="blue.50"
                  borderRadius="10px 10px 0 0"
                >
                  <Text fontWeight="bold">{role.roleName}</Text>

                  {role.assignedTo && !temporarySelections[role.roleId] ? (
                  <Box>
                    {role.status === "Completed" ? (
                      <Text fontSize="14px">
                        Assigned to: <strong>{role.assignedTo}</strong>{" "}
                        {role.status ? `(${role.status})` : ""}
                      </Text>
                    ) : (
                      <Text fontSize="14px">
                        Currently assigned to: <strong>{role.assignedTo}</strong>{" "}
                        {role.status ? `(${role.status})` : ""}
                      </Text>
                    )}
                  </Box>
                ) : (
                  <Text fontSize="14px">Not assigned to anyone</Text>
                )}

                </Flex>
                <Box borderRadius="md">
                  <DropdownInput
                    variant="downSide"
                    dropDownPlace={`List of ${role.roleName}`}
                    options={role.options}
                    menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                    inputStyleCss={{ w: "100%" }}
                    defaultOption={temporarySelections[role.roleId] || role.assignedTo || ""}
                    onClick={(selectedOption) => {
                      handleAssigneeChange(role.roleId, selectedOption);
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        }
        modalFooterBtn={
          <PrimaryButton buttonText="Submit" onClick={handleSubmit} />
        }
      />
    </>
  );
};

export default AssignVisit;
